var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChecklist(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163 4526 c-59 -19 -99 -50 -130 -104 l-28 -47 -3 -745 c-2 -542 0 -756 9 -787 15 -54 72 -121 123 -144 39 -18 84 -19 796 -19 714 0 757 1 795 19 22 10 54 34 72 52 66 70 63 32 63 856 l0 748 -24 51 c-26 56 -74 98 -133 120 -55 19 -1478 19 -1540 0z m1237 -921 l0 -465 -465 0 -465 0 0 465 0 465 465 0 465 0 0 -465z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2465 3816 c-123 -57 -170 -192 -109 -314 32 -65 92 -109 167 -123 35 -6 483 -8 1238 -7 l1184 3 41 22 c53 28 107 91 122 142 34 111 -18 229 -122 277 l-51 24 -1210 0 -1210 0 -50 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1580 1981 c-52 -17 -87 -41 -150 -106 -36 -37 -217 -215 -402 -397 l-338 -330 -172 175 c-164 166 -176 176 -226 187 -106 24 -206 -17 -259 -107 -24 -41 -28 -59 -28 -118 0 -48 6 -81 19 -104 27 -50 513 -549 557 -571 58 -30 109 -34 174 -15 56 16 69 28 559 511 364 360 509 509 529 546 61 112 18 251 -96 309 -44 23 -128 33 -167 20z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2465 1491 c-148 -69 -182 -266 -64 -378 71 -67 -18 -63 1324 -63 997 0 1221 2 1248 13 83 35 147 130 147 217 0 87 -64 182 -147 217 -27 11 -251 13 -1250 13 -1165 0 -1220 -1 -1258 -19z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklist);
export default __webpack_public_path__ + "static/media/checklist.efa3b3b75aa47a5f90108850e9213904.svg";
export { ForwardRef as ReactComponent };